// extracted by mini-css-extract-plugin
export default {"titles":"CustomTabBar_titles__Oqvcf","title":"CustomTabBar_title__IEzeu","titleActive":"CustomTabBar_titleActive__tNkol"};